import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Drawer, Button, ButtonGroup} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(ButtonGroup, {
            'checkType': 'radio',
            'children': [
                _$cc(Button, {
                    'value': 'top',
                    'children': 'top'
                }),
                _$cc(Button, {
                    'value': 'bottom',
                    'children': 'bottom'
                }),
                _$cc(Button, {
                    'value': 'left',
                    'children': 'left'
                }),
                _$cc(Button, {
                    'value': 'right',
                    'children': 'right'
                })
            ],
            'ev-$model:value': function($v) {
                $this.set('placement', $v);
            },
            'value': $this.get('placement')
        }),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Button, {
            'ev-click': this.showDrawer,
            'children': '打开 Drawer'
        }),
        _$cc(Drawer, {
            'title': '可调整大小的 Drawer',
            'placement': this.get('placement'),
            'resizable': true,
            'children': (
                _$ce(2, 'div', [
                    _$ce(2, 'p', '可以通过拖拽边缘来调整 drawer 的大小：', 16 /* HasTextChildren */),
                    _$ce(2, 'ul', [
                        _$ce(2, 'li', [
                            _$ce(2, 'strong', 'top/bottom', 16 /* HasTextChildren */),
                            _$ct('：\n                    '),
                            _$ce(2, 'ul', [
                                _$ce(2, 'li', '宽度：可以通过拖拽右侧边缘来调整宽度，调整时会自动保持居中', 16 /* HasTextChildren */),
                                _$ce(2, 'li', '高度：可以通过拖拽底部（top）或顶部（bottom）边缘来调整高度', 16 /* HasTextChildren */)
                            ], 4 /* HasNonKeyedChildren */)
                        ], 4 /* HasNonKeyedChildren */),
                        _$ce(2, 'li', [
                            _$ce(2, 'strong', 'left', 16 /* HasTextChildren */),
                            _$ct('：可以通过拖拽右侧边缘来调整宽度')
                        ], 4 /* HasNonKeyedChildren */),
                        _$ce(2, 'li', [
                            _$ce(2, 'strong', 'right', 16 /* HasTextChildren */),
                            _$ct('：可以通过拖拽左侧边缘来调整宽度')
                        ], 4 /* HasNonKeyedChildren */)
                    ], 4 /* HasNonKeyedChildren */),
                    _$ce(2, 'p', [
                        _$ct('当前 placement: '),
                        this.get('placement')
                    ], 0 /* UnknownChildren */)
                ], 4 /* HasNonKeyedChildren */)
            ),
            'ev-$model:value': function($v) {
                $this.set('show', $v);
            },
            'value': $this.get('show')
        })
    ], 4 /* HasNonKeyedChildren */);
};